import React from "react";
import { Form, Input } from "antd";

const Contacts = ({ isSmallGridLargeDesktop }) => {
  return (
    <>
      <div className="order-form__section__title">
        <span className="order-form__section__title__text">Контакты</span>
      </div>
      <div
        style={
          isSmallGridLargeDesktop
            ? {
                display: "grid",
                gridTemplateColumns: "repeat(3, 1fr)",
                gap: "20px",
              }
            : {}
        }
      >
        <Form.Item
          name="company_name"
          label="Название компании"
          className="non-floating-form-item"
        >
          <Input
            placeholder=""
            size="large"
            disabled
            className="height-44"
          />
        </Form.Item>
        <Form.Item
          label="Контактное лицо"
          name="contact_name"
          className="non-floating-form-item"
        >
          <Input
            placeholder=""
            size="large"
            // disabled
            className="height-44"
          />
        </Form.Item>
        <Form.Item
          label="Контактный номер"
          name="phone_number"
          className="non-floating-form-item"
        >
          <Input
            placeholder=""
            type="tel"
            size="large"
            // disabled
            className="height-44"
          />
        </Form.Item>
      </div>
      {/* <Form.Item
        label='Адрес электронной почты'
        name='email'
      >
        <Input placeholder='Контактный номер' type='tel' size='large' disabled />
      </Form.Item> */}
    </>
  );
};

export default Contacts;
